import { observer } from 'mobx-react';
import ToYouPicker from './ToYouPicker';
import { ITakerBranch } from '~/types/integrations';
import Text, { TEXT } from '~/view/components/Text/Text';
import { formatBranchLabel } from '~/utils/helpers';
import './style.scss';

interface IProps {
  takerBranch: ITakerBranch | null;
}

const BranchesListRow: React.FC<IProps> = observer(({ takerBranch }) => {
  if (!takerBranch) return null;

  return (
    <div className="to-you-branches-list-row">
      <div className="text-preset__list-row to-you-branches-list-cell w-62-5">
        <Text type={TEXT.LIST_ROW} text={formatBranchLabel(takerBranch.name, takerBranch.address)} className="break-word-for-taker-branches pr-2" />
      </div>
      <div className="to-you-branches-list-cell w-37-5">
        <ToYouPicker takerBranch={takerBranch} />
      </div>
    </div>
  );
});

export default BranchesListRow;
